<div class="sidebar">
  <div id="sidebar-collapse">
    <div class="admin-block d-flex" style="align-items: center;">
      <div>
        <img src="./../../../assets/img/dash/ap.png" class="img-circle" width="45px" />
      </div>
      <div class="admin-info">
        <div class="font-strong" (click)="home()">{{auth.allSystemModuleObj['ACCOUNT']}}</div>
      </div>
    </div>
    <ul class="side-menu metismenu">
      <li>
        <!-- <a class="text-decoration-none" routerLinkActive="active" [hidden]="sidebar['dashbord']" routerLink="/accounts/accounts-index"><i
                        class="sidebar-item-icon fa fa-th-large"></i>
                    <span class="nav-label">{{mainService.allLableShowObj[mainService.language_cd+'Sidebar1']}}
                        Dashboard
                    </span>
                </a> -->
        <a class="text-decoration-none" routerLinkActive="active" (click)="refreshCol()" [hidden]="sidebar['dashbord']"
          routerLink="/accounts/accounts-index"><i class="sidebar-item-icon fa fa-th-large"></i>
          <span class="nav-label">{{mainService.allLableShowObj[mainService.language_cd+'Sidebar1']}}
            <!-- Dashboard -->
          </span>
        </a>
      </li>

      <li routerLinkActive="active" [hidden]="sidebar['report']">
        <a class="text-decoration-none" href="#" data-bs-toggle="collapse" data-bs-target="#collapseReport"
          aria-expanded="false" aria-controls="collapseReport"><i class="sidebar-item-icon fa fa-bar-chart"></i>
          <!-- <a href="javascript:;" [hidden]="sidebar['report']"><i class="sidebar-item-icon fa fa-bar-chart"></i> -->
          <span class="nav-label">{{mainService.allLableShowObj[mainService.language_cd+'Sidebar2']}}
            <!-- Report -->
          </span><i class="fa fa-angle-left arrow"></i></a>
        <ul class="nav-2-level collapse" id="collapseReport" data-bs-parent="#sidebar-collapse">

          <li>
            <a class="text-decoration-none" routerLink="/accounts/ledger/report/ledger-report"
              [hidden]="sidebar['ledger_report']"
              routerLinkActive="active">{{mainService.allLableShowObj[mainService.language_cd+'Sidebar4']}}
              <!-- Ledger Report -->
            </a>
          </li>
          <li>
            <a class="text-decoration-none" routerLink="/accounts/ledger/report/bank-report"
              [hidden]="sidebar['bank_book']"
              routerLinkActive="active">{{mainService.allLableShowObj[mainService.language_cd+'Sidebar5']}}
              <!-- Bank Book -->
            </a>
          </li>
          <li>
            <a class="text-decoration-none" routerLink="/accounts/ledger/report/gst" [hidden]="sidebar['gst_report']"
              routerLinkActive="active">{{mainService.allLableShowObj[mainService.language_cd+'Sidebar6']}}
              <!-- GST -->
            </a>
          </li>
          <li>
            <a class="text-decoration-none" routerLink="/accounts/ledger/report/tds-gst"
              [hidden]="sidebar['tds_on_gst']"
              routerLinkActive="active">{{mainService.allLableShowObj[mainService.language_cd+'Sidebar7']}}
              <!-- TDS on GST -->
            </a>
          </li>
          <li>
            <a class="text-decoration-none" routerLink="/accounts/ledger/report/tds" [hidden]="sidebar['tds']"
              routerLinkActive="active">{{mainService.allLableShowObj[mainService.language_cd+'Sidebar8']}}
              <!-- TDS -->
            </a>
          </li>
          <li>
            <a class="text-decoration-none" routerLink="/accounts/ledger/report/all-ded" [hidden]="sidebar['deduction']"
              routerLinkActive="active">{{mainService.allLableShowObj[mainService.language_cd+'Sidebar9']}}
              <!-- Deductions -->
            </a>
          </li>
          <li>
            <a class="text-decoration-none" routerLink="/accounts/ledger/report/balance-sheet-report"
              [hidden]="sidebar['balance_sheet']" routerLinkActive="active">Balance Sheet</a>
          </li>
          <li>
            <a class="text-decoration-none" routerLink="/accounts/ledger/report/income-expence-report"
              [hidden]="sidebar['inc_exp_report']" routerLinkActive="active">INC/EXP Report</a>
          </li>
          <li>
            <a class="text-decoration-none" routerLink="/accounts/ledger/report/fix-asset"
              [hidden]="sidebar['fixed_assets_report']" routerLinkActive="active">Fixed Assets Report</a>
          </li>
          <li>
            <a class="text-decoration-none" routerLink="/accounts/ledger/report/cogs-report" [hidden]="sidebar['cogs']"
              routerLinkActive="active">COGS Report</a>
          </li>
          <li>
            <a class="text-decoration-none" routerLink="/accounts/ledger/report/receipts-payment"
              [hidden]="sidebar['receipt_payment']" routerLinkActive="active">Receipts & Payment</a>
          </li>
          <li>
            <a class="text-decoration-none" routerLink="/accounts/ledger/report/budget-report"
              routerLinkActive="active">Budget
              Report</a>
          </li>
          <!-- <li>
            <a class="text-decoration-none" routerLink="/accounts/ledger/report/store-keeper-register" [hidden]="sidebar['fixed_assest_register']"
              routerLinkActive="active">Fixed Assets
              Register</a>
          </li> -->
          <!-- <li>
                        <a class="text-decoration-none" routerLink="/accounts/ledger/report/adhoc-report" [hidden]="sidebar['adhoc_report']"
                            routerLinkActive="active">Adhoc Report</a>
                    </li> -->
          <!--  <li>
                            <a class="text-decoration-none" routerLink="/accounts/ledger/report/trail-balance" routerLinkActive="active">GIS</a>
                        </li>
                        <li>
                            <a class="text-decoration-none" routerLink="/accounts/ledger/report/trail-balance" routerLinkActive="active">Labour Cess</a>
                        </li>
                        <li>
                            <a class="text-decoration-none" routerLink="/accounts/ledger/report/trail-balance" routerLinkActive="active">Royality</a>
                        </li> -->
          <!-- <li>
                            <a class="text-decoration-none" routerLink="/accounts/ledger/report/trail-balance" routerLinkActive="active">LIC</a>
                        </li> -->



        </ul>
      </li>


      <li routerLinkActive="active" [hidden]="sidebar['acc_payble']">
        <a [hidden]="sidebar['acc_payble']" class="text-decoration-none" href="#" data-bs-toggle="collapse"
          data-bs-target="#collapsePayable" aria-expanded="false" aria-controls="collapsePayable"><i
            class="sidebar-item-icon fa fa-money"></i>
          <!-- <a href="javascript:;" [hidden]="sidebar['acc_payble']"><i class="sidebar-item-icon fa fa-money"></i> -->
          <span class="nav-label">{{mainService.allLableShowObj[mainService.language_cd+'Sidebar10']}}
            <!-- Accounts Payable -->
          </span><i class="fa fa-angle-left arrow"></i></a>
        <ul class="nav-2-level collapse" id="collapsePayable" data-bs-parent="#sidebar-collapse">
          <li>
            <a class="text-decoration-none" routerLink="/accounts/bill" [hidden]="sidebar['bill']"
              routerLinkActive="active">{{mainService.allLableShowObj[mainService.language_cd+'Sidebar11']}}
              <!-- Bills -->
            </a>
          </li>
          <li>
            <a class="text-decoration-none" routerLink="/accounts/dep-bill" [hidden]="sidebar['dep_bill']"
              routerLinkActive="active">Department Bill
              <!-- Bills -->
            </a>
          </li>
          <li>
            <a class="text-decoration-none" routerLink="/accounts/bank-payment" [hidden]="sidebar['bank_payment']"
              routerLinkActive="active">{{mainService.allLableShowObj[mainService.language_cd+'Sidebar12']}}
              <!-- Bank Payment -->
            </a>
          </li>
          <li>
            <a class="text-decoration-none" routerLink="/accounts/advice" [hidden]="sidebar['advice']"
              routerLinkActive="active">{{mainService.allLableShowObj[mainService.language_cd+'Sidebar13']}}
              <!-- Advice -->
            </a>
          </li>

        </ul>
      </li>
      
      <li routerLinkActive="active">
        <a [hidden]="sidebar['acc_receivable']" class="text-decoration-none" href="#" data-bs-toggle="collapse"
          data-bs-target="#collapseReceivable" aria-expanded="false" aria-controls="collapseReceivable"><i
            class="sidebar-item-icon fa fa-get-pocket"></i>
          <!-- <a href="javascript:;" [hidden]="sidebar['acc_receivable']"><i
                        class="sidebar-item-icon fa fa-get-pocket"></i> -->
          <span class="nav-label">{{mainService.allLableShowObj[mainService.language_cd+'Sidebar14']}}
            <!-- Accounts Receivable -->
          </span><i class="fa fa-angle-left arrow"></i></a>
        <ul class="nav-2-level collapse" id="collapseReceivable" data-bs-parent="#sidebar-collapse">
          <li>
            <a class="text-decoration-none" routerLink="/accounts/challan" [hidden]="sidebar['challan']"
              routerLinkActive="active">{{mainService.allLableShowObj[mainService.language_cd+'Sidebar15']}}
              <!-- Challans -->
            </a>
          </li>
          <li>
            <a class="text-decoration-none" routerLink="/accounts/dep-challan" [hidden]="sidebar['dep_challan']"
              routerLinkActive="active">Department
              Challan
              <!-- Bills -->
            </a>
          </li>
          <!-- <li>
                            <a class="text-decoration-none" routerLink="/accounts/demand"
                                routerLinkActive="active">
                                Demand
                            </a>
                        </li> -->
          <!-- <li>
                            <a class="text-decoration-none" routerLink="/accounts/challan"
                                routerLinkActive="active">
                                Challan Settlement
                            </a>
                        </li> -->

        </ul>
      </li>
      <!-- <li>
                    <a href="javascript:;" routerLinkActive="active"  routerLink="/accounts/event-group"><i class="sidebar-item-icon fa fa-th-large"></i>
                        <span class="nav-label"></span>Event-Group
                    </a>
                </li> -->
      <li routerLinkActive="active" [hidden]="sidebar['trasury']">
        <a class="text-decoration-none" href="#" data-bs-toggle="collapse" data-bs-target="#collapseTreasury"
          aria-expanded="false" aria-controls="collapseTreasury"><i class="sidebar-item-icon fa fa-id-card"></i>
          <!-- <a href="javascript:;" [hidden]="sidebar['trasury']"><i class="sidebar-item-icon fa fa-id-card"></i> -->
          <span class="nav-label">{{mainService.allLableShowObj[mainService.language_cd+'Sidebar17']}}
            <!-- Treasury -->
          </span><i class="fa fa-angle-left arrow"></i></a>
        <ul class="nav-2-level collapse" id="collapseTreasury" data-bs-parent="#sidebar-collapse">
          <li>
            <a class="text-decoration-none" routerLink="/accounts/tresuary/contra" [hidden]="sidebar['contra']"
              routerLinkActive="active">
              Contra
            </a>
          </li>
          <li>
            <a class="text-decoration-none" routerLink="/accounts/tresuary/bank-account"
              [hidden]="sidebar['bank_account']"
              routerLinkActive="active">{{mainService.allLableShowObj[mainService.language_cd+'Sidebar20']}}
              <!-- Bank Account -->
            </a>
          </li>
          <li>
            <a class="text-decoration-none" routerLink="/accounts/tresuary/gateway-mid-configuration"
              [hidden]="sidebar['gateway_mid_config']" routerLinkActive="active">Gateway MID
              Configuration
            </a>
          </li>
          <li>
            <a class="text-decoration-none" routerLink="/accounts/closing-stock" [hidden]="sidebar['closing_stock']"
              routerLinkActive="active">Closing Stock
            </a>
          </li>
        </ul>
      </li>


      <li routerLinkActive="active">
        <a [hidden]="sidebar['ledger']" class="text-decoration-none" href="#" data-bs-toggle="collapse"
          data-bs-target="#collapseLedger" aria-expanded="false" aria-controls="collapseLedger"><i
            class="sidebar-item-icon fa fa-book"></i>
          <!-- <a href="javascript:;" [hidden]="sidebar['ledger']"><i class="sidebar-item-icon fa fa-book"></i> -->
          <span class="nav-label">{{mainService.allLableShowObj[mainService.language_cd+'Sidebar21']}}
            <!-- Ledger -->
          </span><i class="fa fa-angle-left arrow"></i></a>
        <ul class="nav-2-level collapse" id="collapseLedger" data-bs-parent="#sidebar-collapse">
          <li>
            <a class="text-decoration-none" routerLink="/accounts/ledger/jv" [hidden]="sidebar['journal']"
              routerLinkActive="active">
              Journals
            </a>
          </li>
          <li>
            <a class="text-decoration-none" routerLink="/accounts/ledger/report/trail-balance"
              [hidden]="sidebar['trail_balance']"
              routerLinkActive="active">{{mainService.allLableShowObj[mainService.language_cd+'Sidebar3']}}
              <!-- Trial Balance -->
            </a>
          </li>

          <!--   <li>
                            <a class="text-decoration-none" routerLink="/accounts/budget" routerLinkActive="active">{{mainService.allLableShowObj[mainService.language_cd+'Sidebar24']}}
                                    Budget</a>
                        </li> -->

          <li>
            <a class="text-decoration-none" routerLink="/accounts/ledger/jrnl" [hidden]="sidebar['manual_jrnl']"
              routerLinkActive="active">
              Manual Journal
            </a>
          </li>


        </ul>
      </li>
      <li routerLinkActive="active" [hidden]="sidebar['administration']">
        <a class="text-decoration-none" href="#" data-bs-toggle="collapse" data-bs-target="#collapseAdmin"
          aria-expanded="false" aria-controls="collapseAdmin"><i class="sidebar-item-icon fa fa-user-plus"></i>
          <!-- <a href="javascript:;" [hidden]="sidebar['administration']"><i
                        class="sidebar-item-icon fa fa-user-plus"></i> -->
          <span class="nav-label">{{mainService.allLableShowObj[mainService.language_cd+'Sidebar29']}}
            <!-- Administration -->
          </span><i class="fa fa-angle-left arrow"></i></a>
        <ul class="nav-2-level collapse" id="collapseAdmin" data-bs-parent="#sidebar-collapse">
          <div id="adminParent">
            <li routerLinkActive="active" [hidden]="sidebar['master']">
              <a class="text-decoration-none" href="#" data-bs-toggle="collapse" data-bs-target="#collapseMaster"
                aria-expanded="false" aria-controls="collapseMaster"><i class="sidebar-item-icon"></i>
                <!-- <a href="javascript:;" [hidden]="sidebar['master']"><i class="sidebar-item-icon "></i> -->
                <span class="nav-label">
                  <!-- {{mainService.allLableShowObj[mainService.language_cd+'Sidebar21']}} -->
                  Master Data
                </span><i class="fa fa-angle-left arrow"></i></a>
              <ul class="nav-3-level collapse" id="collapseMaster" data-bs-parent="#adminParent">
                <li>
                  <a class="text-decoration-none" routerLink="/accounts/setting/code-value"
                    [hidden]="sidebar['code_value']"
                    routerLinkActive="active">{{mainService.allLableShowObj[mainService.language_cd+'Sidebar41']}}
                    <!-- Code-Value -->
                  </a>
                </li>
                <li>
                  <a class="text-decoration-none" routerLink="/accounts/setting/fin-year" [hidden]="sidebar['fin_year']"
                    routerLinkActive="active">
                    <!-- {{mainService.allLableShowObj[mainService.language_cd+'Sidebar23']}} -->
                    Fiscal Year
                  </a>
                </li>
                <!-- <li>
                                      <a class="text-decoration-none" routerLink="/accounts/ledger/coa" routerLinkActive="active">{{mainService.allLableShowObj[mainService.language_cd+'Sidebar33']}} -->
                <!-- Chart Of Account -->
                <!-- </a>
                                  </li> -->
                <li>
                  <a class="text-decoration-none" routerLink="/accounts/ledger/org-hier"
                    [hidden]="sidebar['organisation_hier']" routerLinkActive="active">Organization
                  </a>
                </li>

                <li>
                  <a href="javascript:;" routerLinkActive="active" [hidden]="sidebar['cost_center']"
                    routerLink="/accounts/cost-center">
                    <span class="nav-label"></span>Cost Center
                  </a>
                </li>

                <li>
                  <a class="text-decoration-none" routerLink="/accounts/ledger/events"
                    [hidden]="sidebar['business_event']" routerLinkActive="active">
                    <!-- {{mainService.allLableShowObj[mainService.language_cd+'Sidebar31']}} -->
                    Business Event
                  </a>
                </li>
                <!--  <li>
                                      <a class="text-decoration-none" routerLink="/accounts/ledger/report/party-report" routerLinkActive="active">Chart of Account (Ledger)</a>
                                  </li> -->

                <!-- <li>
                  <a class="text-decoration-none" routerLink="/accounts/setting/poAdvance" routerLinkActive="active">Advance PO

                  </a>
                </li> -->

                <li>
                  <a class="text-decoration-none" routerLink="/accounts/ledger/rule" [hidden]="sidebar['acc_rule']"
                    routerLinkActive="active">{{mainService.allLableShowObj[mainService.language_cd+'Sidebar32']}}
                    <!-- Accounting Rule -->
                  </a>
                </li>

              </ul>
            </li>

            <!--
                          <li>
                              <a class="text-decoration-none" routerLink="/accounts/setting/hsn" routerLinkActive="active">
                                  GST
                              </a>
                          </li>
                          <li>
                              <a class="text-decoration-none" routerLink="/accounts/setting/deduction-mapping" routerLinkActive="active">
                                  Deduction Mapping
                              </a>
                          </li> -->

            <li routerLinkActive="active" [hidden]="sidebar['hierarchy']">
              <a class="text-decoration-none" href="#" data-bs-toggle="collapse" data-bs-target="#collapseHier"
                aria-expanded="false" aria-controls="collapseHier"><i class="sidebar-item-icon"></i>
                <!-- <a href="javascript:;" [hidden]="sidebar['hierarchy']"> -->
                <span class="nav-label">
                  Hierarchy
                </span><i class="fa fa-angle-left arrow"></i></a>
              <ul class="nav-2-level collapse" id="collapseHier" data-bs-parent="#adminParent">
                <li>
                  <a class="text-decoration-none" routerLink="/accounts/ledger/bud-hier" [hidden]="sidebar['bud_hier']"
                    routerLinkActive="active">{{mainService.allLableShowObj[mainService.language_cd+'Sidebar24']}}
                    <!-- Budget Hierarchy -->
                  </a>
                </li>
                <li>
                  <a class="text-decoration-none" routerLink="/accounts/ledger/activity-hier"
                    [hidden]="sidebar['act_hier']"
                    routerLinkActive="active">{{mainService.allLableShowObj[mainService.language_cd+'Sidebar36']}}
                    <!-- Activity Hierarchy -->
                  </a>
                </li>
                <li>
                  <a class="text-decoration-none" routerLink="/accounts/ledger/proj-hier"
                    [hidden]="sidebar['proj_hier']"
                    routerLinkActive="active">{{mainService.allLableShowObj[mainService.language_cd+'Sidebar35']}}
                    <!-- Project Hierarchy -->
                  </a>
                </li>

                <li>
                  <a class="text-decoration-none" routerLink="/accounts/ledger/prod-hier"
                    [hidden]="sidebar['prod_hier']"
                    routerLinkActive="active">{{mainService.allLableShowObj[mainService.language_cd+'Sidebar37']}}
                    <!-- Product Hierarchy -->
                  </a>
                </li>
                <li>
                  <a class="text-decoration-none" routerLink="/accounts/ledger/coa" [hidden]="sidebar['coa']"
                    routerLinkActive="active">{{mainService.allLableShowObj[mainService.language_cd+'Sidebar33']}}
                    <!-- Chart Of Account -->
                  </a>
                </li>
              </ul>
            </li>

            <li routerLinkActive="active" [hidden]="sidebar['security']">
              <a class="text-decoration-none" href="#" data-bs-toggle="collapse" data-bs-target="#collapseSecurity"
                aria-expanded="false" aria-controls="collapseSecurity"><i class="sidebar-item-icon"></i>
                <!-- <a href="javascript:;" [hidden]="sidebar['security']"> -->
                <span class="nav-label">
                  <!-- {{mainService.allLableShowObj[mainService.language_cd+'Sidebar42']}} -->
                  Security
                </span><i class="fa fa-angle-left arrow"></i></a>
              <ul class="nav-2-level collapse" id="collapseSecurity" data-bs-parent="#adminParent">


                <li>
                  <a class="text-decoration-none" routerLink="/accounts/administration/roles" [hidden]="sidebar['role']"
                    routerLinkActive="active">
                    {{mainService.allLableShowObj[mainService.language_cd+'Sidebar43']}}
                    <!-- Role -->
                  </a>
                </li>
                <li>
                  <a class="text-decoration-none" routerLink="/accounts/administration/users" [hidden]="sidebar['user']"
                    routerLinkActive="active">
                    <!-- {{mainService.allLableShowObj[mainService.language_cd+'Sidebar44']}} -->
                    Role Authorization
                    <!-- Users Role Authorization -->
                  </a>
                </li>

                <li>
                  <a class="text-decoration-none" routerLink="/accounts/administration/dataAuth"
                    [hidden]="sidebar['data_auth']" routerLinkActive="active">
                    <!-- {{mainService.allLableShowObj[mainService.language_cd+'Sidebar44']}} -->
                    Work Authorization
                    <!-- Users Role Authorization -->
                  </a>
                </li>
                <li>
                  <a class="text-decoration-none" routerLink="/accounts/administration/account-appr"
                    [hidden]="sidebar['workflow']" routerLinkActive="active">
                    WorkFlow
                  </a>
                </li>

                <!-- <li>
                                      <a class="text-decoration-none" routerLink="/accounts/administration/hierarchy" routerLinkActive="active">
                                              {{mainService.allLableShowObj[mainService.language_cd+'Sidebar45']}}
                                               Hierarchy
                                          </a>
                                  </li> -->
                <!-- <li>
                                      <a class="text-decoration-none" routerLink="/accounts/administration/data-assignment" routerLinkActive="active">
                                              {{mainService.allLableShowObj[mainService.language_cd+'Sidebar47']}}
                                              Data Assignment
                                          </a>
                                  </li> -->
                <!-- <li>
                                      <a class="text-decoration-none" routerLink="/accounts/administration/account-appr" routerLinkActive="active">
                                          WorkFlow
                                      </a>
                                  </li> -->
              </ul>
            </li>
            <!-- <li>
              <a class="text-decoration-none" routerLinkActive="active" routerLink="/accounts/setting/party" [hidden]="sidebar['party']">
                <span class="nav-label">
                  Party/Vendor
                </span>
              </a>
            </li> -->
            <!-- <li>
              <a class="text-decoration-none" routerLinkActive="active" routerLink="/accounts/setting/work" [hidden]="sidebar['work']">
                <span class="nav-label">
                  File
                </span>
              </a>
            </li> -->
            <li>
              <a class="text-decoration-none" routerLinkActive="active" routerLink="/accounts/setting/reimbursement"
                [hidden]="sidebar['reimbursement']">
                <span class="nav-label">
                  PO Reimbursement
                </span>
              </a>
            </li>
            <li>
              <a class="text-decoration-none" routerLinkActive="active"
                routerLink="/accounts/setting/poReimbursementEvent" [hidden]="sidebar['reimbursement_event']">
                <span class="nav-label">
                  PO Reimbursement Event
                </span>
              </a>
            </li>

            <li>
              <a class="text-decoration-none" routerLink="/accounts/setting/project-bank"
                [hidden]="sidebar['proj_bank']" routerLinkActive="active">
                Project Bank Account
              </a>
            </li>
            <li>
              <a class="text-decoration-none" routerLink="/accounts/setting/fixed-assets-mapping"
                [hidden]="sidebar['fixed_assets_mapping']" routerLinkActive="active">
                Fixed Asset Mapping
              </a>
            </li>




            <!-- <li>
                              <a class="text-decoration-none" routerLink="/accounts/setting/fields" routerLinkActive="active">Fields</a>
                          </li> -->
            <li>
              <a class="text-decoration-none" routerLink="/accounts/setting/deduction-mapping"
                [hidden]="sidebar['deduction_mapping']" routerLinkActive="active">
                Deduction Mapping
              </a>
            </li>
            <li>
              <a class="text-decoration-none" routerLink="/accounts/setting/hsn" [hidden]="sidebar['gst']"
                routerLinkActive="active">GST</a>
            </li>
            <li>
              <a class="text-decoration-none" routerLink="/accounts/setting/acc-mapping"
                [hidden]="sidebar['accoun_mapping']" routerLinkActive="active"> Account Mapping
              </a>
            </li>

          </div>


        </ul>
      </li>
      <!-- <li>
        <a class="text-decoration-none"routerLinkActive="active" routerLink="/accounts/setting/work" [hidden]="sidebar['work']">   </i>
          <span class="nav-label">
            File
          </span>
         
        </a>
      </li> -->
      <li>

        <a class="text-decoration-none" routerLinkActive="active" (click)="refreshCol()"
          routerLink="/accounts/setting/work" [hidden]="sidebar['work']">
          <i class=" sidebar-item-icon fa fa-file" aria-hidden="true"></i>
          <span class="nav-label">File </span>
        </a>
      </li>
      <li routerLinkActive="active">
        <a class="text-decoration-none" href="#" data-bs-toggle="collapse" data-bs-target="#collapseHelp"
          aria-expanded="false" aria-controls="collapseHelp"><i class="sidebar-item-icon fa fa-question-circle"></i>
          <!-- <a href="javascript:;"><i class="sidebar-item-icon fa fa-question-circle"></i> -->
          <span class="nav-label">{{mainService.allLableShowObj[mainService.language_cd+'Sidebar48']}}
            <!-- Help -->
          </span><i class="fa fa-angle-left arrow"></i></a>
        <ul class="nav-2-level collapse" id="collapseHelp" data-bs-parent="#sidebar-collapse">
          <li>
            <a class="text-decoration-none" routerLink="/accounts/help/faq"
              routerLinkActive="active">{{mainService.allLableShowObj[mainService.language_cd+'Sidebar49']}}
              <!-- FAQ -->
            </a>
          </li>
          <li>
            <a class="text-decoration-none" routerLink="/accounts/help/doc"
              routerLinkActive="active">{{mainService.allLableShowObj[mainService.language_cd+'Sidebar50']}}
              <!-- User Manual -->
            </a>
          </li>
          <li>
            <a class="text-decoration-none" routerLink="/accounts/help/videos"
              routerLinkActive="active">{{mainService.allLableShowObj[mainService.language_cd+'Sidebar51']}}
              <!-- Tutorial Videos -->
            </a>
          </li>
          <li>
            <a class="text-decoration-none" routerLink="/accounts/help/online-support"
              routerLinkActive="active">{{mainService.allLableShowObj[mainService.language_cd+'Sidebar52']}}
              <!-- Online Support -->
            </a>
          </li>
        </ul>
      </li>



    </ul>
  </div>
</div>